<template>
  <div class="index" :style="{ paddingTop: 0.1 + 'rem' }">
    <!-- <Header ref="header" title="忘记用户名" :back="true" left="" /> -->
    <div class="windowmain">
      <div class="boxmain">
       <div class="boxstep">
          <div class="stepitem stepitemactive" style="flex: 0.7">
            <p class="itemp1">1</p>
            <p class="stepline"></p>
            <p class="itemp2">选择用户类型</p>
          </div>
          <div class="stepitem stepitemactive" style="flex: 0.8">
            <p class="itemp1">2</p>
            <p class="stepline2"></p>
            <p class="itemp2">安全验证</p>
          </div>
          <div class="stepitem stepitemactive" style="flex: 0.8">
            <p class="itemp1">3</p>
            <p class="stepline3"></p>
            <p class="itemp2">查看用户名</p>
          </div>
          <!-- <div class="stepitem" style="flex: 0.5">
            <p class="itemp1">4</p>

            <p class="itemp2">完成</p>
          </div> -->
        </div>
        <div class="v_showdiv"></div>
        <div class="boxinput">
          <div class="boxend">
               <div class="endImg"><img src="@/views/image/userregister/icon_pass.png" alt="" /></div>
               <div class="endTxt">
                <p class="end_p1">找回用户名成功！</p>
                <p  class="end_p2">请妥善保管您的用户名</p>
                <p  class="end_p3 end_p4">用户名：{{ userName }} <span class="copylink" @click="copy"><img class="iconImg" src="@/views/image/userregister/copy.png" alt="" srcset=""> 复制</span></p>    
  
                </div> 
            </div>
        

          
        </div>
      </div>

      <div style="margin: 22px">
                <van-button
          type="primary"
          style="width:100%;height:1.07rem;font-size: 0.426667rem"
          size="small"
          @click="gologin"
          >去登录</van-button
        >
      </div>
      <!-- <div style="margin: 22px">
        <van-button
          class=""
          size="large"
          @click="fromSubmit()"
          >忘记密码</van-button
        >
      </div> -->
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";

import {
  Col,
  Row,
  Button,
  Toast,
  Icon
} from "vant";

export default {
  name: "restNameEnd",
  data() {
    return {
      statusBar: 0,
      userName:this.$route.query.userName
    };
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(45);
  },

  methods: {
      gologin(){
        this.$nativeApi.jumpLogin(JSON.stringify({accountName:this.userName}))
      },
      // copy(){
      //   navigator.clipboard.writeText(this.userName)
      //   this.$toast('复制成功~')
      // },
    async copy() {
      try {
        await navigator.clipboard.writeText(this.userName)
        this.$toast('复制成功') // 或 alert
      } catch (err) {
        console.error('复制失败', err)
        this.fallbackCopy(this.userName)
      }
    },
    // 备用方案：使用 document.execCommand（兼容旧浏览器）
    fallbackCopy(text) {
      const input = document.createElement('input')
      input.setAttribute('value', text)
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        this.$toast('复制成功')
      } catch (err) {
        this.$toast('复制失败，请手动选择复制')
      }
      document.body.removeChild(input)
    },
  },

  components: {
    // Header,
    [Button.name]: Button,
    [Col.name]: Col,
    [Row.name]: Row,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/public.scss";
@import "@/views/css/userindex.scss";
.index{
 height: calc(100% - 45px);
    background: #fff;
}
.copylink{
  color: #00599c;
  display:inline-flex;
  align-items: center;
}
.iconImg{
  margin: 0 4px 0 14px;
  width: 24px;
}
.windowmain {
  width: 100%;
     .v_showdiv {
    height: 12px;
    background: #f7f8fa;
  }
  .boxmain {
    width: 100%;
    margin-bottom: 0px;
    .boxTitle {
      font-size: 16px;
      color: #333;
      font-weight: bold;
      margin: 20px 0px 10px 15px;
    }
      .boxstep {
      width: auto;
      background: #fff;
      height: auto;
      display: flex;
      padding: 14px 11px 16px 11px;
      .stepitem {
        flex: 1;
        position: relative;
        text-align: center;
        .stepline {
          position: absolute;
          width: 84px;
          height: 1px;
          background: #00599c;
          left: 70px;
          top: 9px;
        }
        .stepline2 {
          position: absolute;
          width: 94px;
          height: 1px;
          background: #00599c;
          left: 76px;
          top: 9px;
        }
        .itemp1 {
          width: 17px;
          height: 17px;
          background: #d5d5d5;
          font-size: 11px;
          color: #fff;
          text-align: center;
          border-radius: 50%;
          line-height: 18px;
          display: block;
          position: relative;
          margin: 0 auto;
        }
        .itemp2 {
          font-size: 12px;
          color: #999;
          margin-top: 6px;
        }
      }
      .stepitemactive {
        .itemp1 {
          background: #00599c;
        }
        .itemp2 {
          color: #00599c;
        }
      }
    }
  }
.nav_btn{
  text-align: center;
  font-size: 14px;
  text-decoration: underline;
  color: #096ac6;
}
  .boxinput {
 
    height: auto;
    border-radius: 4px;
    background: #fff;
    padding: 10px 0px;
    .boxend{
      width: 100%;
      text-align: center;
      padding-bottom: 20px;
      .endTxt{
        width: 100%;
        height: auto;
        background-image: url('~@/views/image/userregister/icon_endbg.png');
        background-size: cover;
      }
      .endImg{
        width: 36px;
        height: 36px;
        margin: 70px auto 0;
        margin-bottom: 6px;
        img{
          width: 100%;
        }
      }
      .end_p1,.end_p2{
        font-size: 15px;
        color: #333;
        line-height: 30px;
        font-weight: bold;
      }
      .end_p3{
        font-size: 12px;
        line-height: 18px;
        color: #666;

      }
      .end_p4{
        margin-top: 16px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 24px;
      }
    }
 
  }
  .ftBton {
    padding: 0px 15px;
    font-size: 11px;
    color: #999;
  }
  ::v-deep .van-checkbox__icon {
    height: 0.9rem;
  }
  ::v-deep .van-checkbox__icon .van-icon {
    font-size: 11px;
  }
  ::v-deep .van-checkbox__label {
    color: #999;
    span {
      color: #096ac6;
    }
  }
}
</style>